import {LayerMenuItem} from "./layer-menu-item.model";

export class LayerMenuBlock {
  arrowClasses : Object;
  desplegat: boolean ;
  capesVisibles : number ;
  blockId: string;
  blockName: string;
  blockContent:Array<LayerMenuItem> = [];
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/models/layer-menu-block.model.ts